document.addEventListener("DOMContentLoaded", function () {


  // Anchor
  const scrollToElements = document.querySelectorAll('.js--scroll-to');

  scrollToElements.forEach(element => {
    element.addEventListener('click', function (event) {
      event.preventDefault();
      document.querySelector('.header__burger').classList.remove('header__burger_active');
      document.querySelector('.header__content').classList.remove('header__content_show');

      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });



  // Scroll Start
  const scrollToTop = document.querySelector('.js--top');

  if (scrollToTop) {
    scrollToTop.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }


  // Hack Height Mobile
  function appHeight() {
    const doc = document.documentElement;
    doc.style.setProperty('--vh', (window.innerHeight * 0.01) + 'px');
  }

  window.addEventListener('resize', appHeight);
  appHeight();
});
